import { render, staticRenderFns } from "./OrgPicker.vue?vue&type=template&id=937370dc&scoped=true"
import script from "./OrgPicker.vue?vue&type=script&lang=js"
export * from "./OrgPicker.vue?vue&type=script&lang=js"
import style0 from "./OrgPicker.vue?vue&type=style&index=0&id=937370dc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "937370dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('937370dc')) {
      api.createRecord('937370dc', component.options)
    } else {
      api.reload('937370dc', component.options)
    }
    module.hot.accept("./OrgPicker.vue?vue&type=template&id=937370dc&scoped=true", function () {
      api.rerender('937370dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/OrgPicker.vue"
export default component.exports